import React, { useCallback, useState } from "react";
import { SectionHeading } from "../../../components/section-heading";
import { FormattedMessage } from "react-intl";
import { Alert, Button, Card } from "react-bootstrap";
import InventoryResultRenderer from "../../inventory/multiUpdate/inventoryResultRenderer";
import { useDropzone } from "react-dropzone";
import { withAuthorizationVerifier } from "../../../components/authorization-verifier";
import { Container, ButtonContainer, DropzoneContainer, ResultContainer } from "./styles";
import { messages } from "./messages";
import { FullWidthLoader } from "../../../components/full-width-loader";

interface OperationError {
  message: string;
}

const UpgradeTier = (): JSX.Element => {
  const [file, setFile] = useState<File | undefined>(undefined);
  const [isLoading] = useState<boolean>(false);
  const [error] = useState<OperationError | null | undefined>(undefined);
  const [result] = useState<any>(undefined);

  const onDrop = useCallback(<T extends File>(acceptedFiles: T[]) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }
    setFile(acceptedFiles[0]);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleImport = useCallback(() => {
    // TODO: to be implemented
  }, []);

  if (isLoading) {
    return <FullWidthLoader />;
  }
  return (
    <>
      <SectionHeading>
        <FormattedMessage {...messages.title} />
      </SectionHeading>
      <Card className="ml-4 mr-4 mb-4 mt-4">
        <Container>
          <FormattedMessage {...messages.description} />
          <DropzoneContainer {...getRootProps()}>
            <input {...getInputProps()} />
            {file ? <div>{file.name}</div> : <FormattedMessage {...messages.dropHere} />}
          </DropzoneContainer>
        </Container>
        {error && (
          <Alert variant="danger">
            <strong>
              <FormattedMessage {...messages.saveError} />
            </strong>
          </Alert>
        )}
        <ButtonContainer>
          <Button variant="primary" type="button" onClick={handleImport}>
            <FormattedMessage {...messages.import} />
          </Button>
          <Button variant="primary" type="button">
            <FormattedMessage {...messages.exportToExcel} />
          </Button>
        </ButtonContainer>
        {result && (
          <ResultContainer>
            <Alert variant="success">
              <strong>
                <FormattedMessage {...messages.saveSuccess} />
              </strong>
            </Alert>
            <InventoryResultRenderer inventoryResult={result} update />
          </ResultContainer>
        )}
      </Card>
    </>
  );
};

export default withAuthorizationVerifier(UpgradeTier);
